<script>
import SvgLoader from 'components/svg_loader.vue';

export default {
  components: {
    SvgLoader
  },

  props: {
    name: {
      type: String,
      required: true
    },
    rating: {
      type: Number,
      required: false,
      default: null
    },
    jobTitle: {
      type: String,
      required: false,
      default: null
    },
    text: {
      type: String,
      required: true
    },
    companyName: {
      type: String,
      required: false,
      default: null
    },
    imageUrl: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      starCount: 5,
      starSvg: 'payment_page/testimonial_star',
    };
  }
};
</script>

<template>
  <div class="c-testimonial me-3">
    <img
      v-if="imageUrl"
      :src="imageUrl"
    >

    <div>
      <div class="d-flex mb-3">
        <h3 class="m-0">
          {{ name }}
        </h3>
      </div>

      <div class="c-testimonial__stars mb-3">
        <template v-if="rating">
          <svg-loader
            v-for="index in starCount"
            :key="index"
            class="c-testimonial__star"
            :class="rating >= index ? 'c-testimonial__star--filled' : ''"
            :path="starSvg"
          />
        </template>
      </div>

      <p class="m-0 mb-3">
        {{ text }}
      </p>

      <div
        v-if="jobTitle || companyName"
        class="d-flex align-items-flex-end"
      >
        <h4 class="m-0">
          {{ jobTitle }}

          <span v-if="companyName">
            {{ `${jobTitle ? ' - ' : ''}${companyName}` }}
          </span>
        </h4>
      </div>
    </div>
  </div>
</template>
